import { RouteRecordRaw } from "vue-router";

export const userListRoute: RouteRecordRaw = {
  path: "/users",
  name: "USER_LIST",
  component: () => import("@/pages/user/Page.vue"),
  meta: {
    title: "Список пользователей",
    activeLinkGroup: "USERS",
    sort: 1,
    sidebar: {
      icon: "person",
      label: "Пользователи",
    },
  },
};

export const userCreateRoute: RouteRecordRaw = {
  path: "/users/create",
  name: "USER_CREATE",
  component: () => import("@/pages/user/Create.vue"),
  meta: {
    title: "user create",
    activeLinkGroup: "USERS",
    accsess: async (permissions: string[]) => {
      return permissions.some((p) => p === "USER_CREATE");
    },
  },
};

export const userEditRoute: RouteRecordRaw = {
  path: "/users/edit/:id",
  props: true,
  name: "USERS_EDIT",
  component: () => import("@/pages/user/Edit.vue"),
  meta: {
    title: "user edit",
    activeLinkGroup: "USERS",
    accsess: async (permissions: string[]) => {
      return permissions.some((p) => p === "USER_EDIT");
    },
  },
};
